import { render, staticRenderFns } from "./FormIndex.vue?vue&type=template&id=3bf5b8ec&scoped=true&"
import script from "./FormIndex.vue?vue&type=script&lang=js&"
export * from "./FormIndex.vue?vue&type=script&lang=js&"
import style0 from "./FormIndex.vue?vue&type=style&index=0&id=3bf5b8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5b8ec",
  null
  
)

export default component.exports